import ngDeps from './ngDeps';

export function getCurrentUser() {
  const { Auth } = ngDeps;
  return Auth.getCurrentUser();
}

export function getAccessToken() {
  const { LoopBackAuth } = ngDeps;
  return LoopBackAuth.accessTokenId;
}

export function getCurrentCompany() {
  const { $rootScope } = ngDeps;
  return $rootScope.currentCompany;
}

export function logout() {
  const { $rootScope } = ngDeps;
  $rootScope.logout();

  console.log('logout auth service');
}
